<template>
    <div class="behavior-report-feedback-rating-item-grid">
        <!-- statement with pronouns -->

        {{ insertNameAndPronouns(item.statement) }}
        <!-- report card form -->
        <table class="table table-bordered" v-if="landscape">
            <thead>
                <tr>
                    <th style="width: 30%" class="text-center">Options</th>
                    <th class="text-center" v-for="period in reportingPeriods">{{ period.text }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th style="width: 30%">
                        <table class="table table-internal">
                            <tbody>
                                <tr v-if="showOptionLabels">
                                    <template v-for="(opt, idx) in options" class="text-center">
                                        <td
                                            v-if="opt.label !== ''"
                                            class="text-center"
                                            :colspan="labelColSpan(idx)"
                                        >{{ opt.label }}</td>
                                    </template>
                                </tr>
                                <tr v-if="showOptionValues">
                                    <td v-for="opt in options" class="text-center">{{ opt.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </th>
                    <th v-for="period in reportingPeriods">
                        <table class="table table-internal table-borderless">
                            <tbody>
                                <tr v-if="showPointsBlank">
                                    <td class="text-center">_____{{ blankUnits }}</td>
                                </tr>
                                <template v-else>
                                    <template v-if="showOptionsHorizontal(responseFormat)">
                                        <tr class="text-center">
                                            <td
                                                v-for="opt in options"
                                                v-if="showOptionLabels"
                                            >{{ opt.label }}</td>
                                        </tr>
                                        <tr class="text-center">
                                            <td
                                                v-for="opt in options"
                                                v-if="showOptionValues"
                                            >{{ opt.value }}</td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr v-for="opt in options" class="text-center">
                                            <td v-if="showOptionLabels">{{ opt.label }}</td>
                                            <td v-if="showOptionValues">{{ opt.value }}</td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </th>
                </tr>
            </tbody>
        </table>

        <table class="table table-bordered" v-else>
<!--            <thead>-->
<!--                <tr>-->
<!--                    <th v-if="reportingPeriods.length > 1"></th>-->
<!--                    <th class="text-center" v-for="period in reportingPeriods">{{ period.text }}</th>-->
<!--                </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--                <tr v-for="opt in options">-->
<!--                    <th>-->
<!--                        <span class="pr-2" v-if="showOptionValues">{{ opt.value }}</span>-->
<!--                        <span v-if="showOptionLabels">{{ opt.label }}</span>-->
<!--                    </th>-->
<!--                    <td class="text-center" v-for="period in reportingPeriods">-->
<!--                        &lt;!&ndash; TODO: use image here (funny chars or bordered divs don't work with cloudformatter) &ndash;&gt;-->
<!--                        <div class="dbr-mock-radio">o</div>-->
<!--                    </td>-->
<!--                </tr>-->
                <template v-for="period in reportingPeriods">
                    <tr v-if="showOptionLabels">
                        <td v-if="reportingPeriods.length > 1" :rowspan="portraitModeRowsPerPeriod">
                            {{ period.text }}
                        </td>
                        <template v-for="(opt, idx) in options" class="text-center">
                            <td
                                v-if="opt.label !== ''"
                                class="text-center"
                                :colspan="labelColSpan(idx)"
                            >{{ opt.label }}</td>
                        </template>
                    </tr>
                    <tr v-if="showOptionValues">
                        <td v-if="!showOptionLabels && reportingPeriods.length > 1" :rowspan="portraitModeRowsPerPeriod">
                            {{ period.text }}
                        </td>
                        <td v-for="opt in options" class="text-center">
                            {{ opt.value }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center" v-for="opt in options">
                            <!-- TODO: use image here (funny chars or bordered divs don't work with cloudformatter) -->
                            <div class="dbr-mock-radio">o</div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>

import Vue from 'vue'
import ToolMixin from '@/providers/ToolMixin'

export default Vue.extend({
    name: "BehaviorReportFeedbackRatingItemGrid",
    mixins: [ToolMixin],
    props: {
        item: Object,
        landscape: Boolean,
    },
    computed: {
        responseFormat() {
            return this.getResponseFormat(this.item.responseFormat)
        },
        showOptionLabels() {
            return this.responseFormat.showOptionLabels
        },
        showOptionValues() {
            return this.responseFormat.showOptionValues
        },
        portraitModeRowsPerPeriod() {
            let rows = 1
            if (this.showOptionLabels) rows += 1
            if (this.showOptionValues) rows += 1
            return rows
        },
        showPointsBlank() {
            return this.responseFormat.showPointsBlank
        },
        blankUnits() {
            return this.responseFormat.blankUnits
        },
        options() {
            return this.responseFormat.options
        },
        reportingPeriods() {
            return this.docData.reportingPeriods ? this.docData.reportingPeriods : []
        }
    },
    methods: {
        getResponseFormat(title) {
            const format = _.find(this.config.behaviorReport.responseFormats, (rf) => {
                return rf.title == title
            })
            return format ? format : {}
        },
        insertNameAndPronouns(statement) {
            const name = this.docData.studentName;
            const pronouns = this.docData.studentPronouns; // he/she/they

            if (name && name.length > 0) {
                statement = statement.replaceAll('[STUDENT]', name);
            } else {
                statement = statement.replaceAll('[STUDENT]', 'Student');
            }
            if (pronouns == 'he') {
                statement = statement.replaceAll('[THEIR]', 'his');
                statement = statement.replaceAll('[THEY]', 'he');
                statement = statement.replaceAll('[THEM]', 'him');
            } else if (pronouns == 'she') {
                statement = statement.replaceAll('[THEIR]', 'her');
                statement = statement.replaceAll('[THEY]', 'she');
                statement = statement.replaceAll('[THEM]', 'her');
            } else {
                statement = statement.replaceAll('[THEIR]', 'their');
                statement = statement.replaceAll('[THEY]', 'they');
                statement = statement.replaceAll('[THEM]', 'them');
            }

            return statement;
        },
        labelColSpan(index) {
            let nonNullLabels = 0
            this.options.forEach((opt) => {
                if (opt.label !== "" && opt.label != null) {
                    nonNullLabels++
                }
            })
            return Math.floor(this.options.length / nonNullLabels)
        },
        showOptionsHorizontal(format) {
            return format.showHorizontal ? format.showHorizontal : false
        }
    }
})

</script>

<style lang="scss">
.behavior-report-feedback-rating-item-grid {
    margin-top: 0px;

    table,
    th,
    td,
    tr {
        margin-top: 0px !important;
        table-layout: fixed;
        padding: 0.5em;
    }

    .table-internal {
        th,
        td,
        tr {
            border: 0 solid #ffffff !important;
            margin: 0 auto;
        }
    }

    .dbr-mock-radio {
        margin: 0 auto;
        font-size: 24px;
        font-weight: normal;
        line-height: 16px;
        color: #999;
        font-family: sans-serif !important;
    }

    @media print {
        margin: 0;
    }
}
</style>
